goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Printer$default");
shadow.js.shim.module$$carbon$icons_react$es$Printer$default = shadow.js.require(369, {}).default;
